import { useCallback, useEffect, useState } from 'react';
import ServiceColumnPreferences from '@/services/ServiceColumnPreferences';
import { notify } from '@/stores/useToast';

/**
 * Preferência de colunas visíveis, persistida por usuário no backend (CON-5157).
 * Falha de leitura é silenciosa (mantém todas as colunas visíveis); falha de
 * gravação mostra toast, já que é resultado de uma ação explícita do usuário.
 */
export function useColumnPreferences(tableId: string) {
  const [hiddenColumnKeys, setHiddenColumnKeys] = useState<Set<string>>(new Set());

  useEffect(() => {
    let cancelled = false;
    ServiceColumnPreferences.get(tableId)
      .then(({ data }) => {
        if (!cancelled) setHiddenColumnKeys(new Set(data?.hiddenColumns ?? []));
      })
      .catch(() => {
        /* silencioso — mantém todas as colunas visíveis */
      });
    return () => {
      cancelled = true;
    };
  }, [tableId]);

  const toggleColumn = useCallback(
    (key: string, visible: boolean) => {
      setHiddenColumnKeys((prev) => {
        const next = new Set(prev);
        if (visible) next.delete(key);
        else next.add(key);
        ServiceColumnPreferences.save(tableId, Array.from(next)).catch(() =>
          notify.error('Não foi possível salvar a preferência de colunas.'),
        );
        return next;
      });
    },
    [tableId],
  );

  return { hiddenColumnKeys, toggleColumn };
}
